import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import ActivityCategory from '../../entities/activityCategory';
import ActivityType from '../../entities/activityType';

/*
 * Delete/nullify anywhere this activityCategory is used in other entities
 *
 * @param {ActivityCategory} activityCategory
 */
export function deleteActivityCategory(activityCategory: ActivityCategory, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = activityCategory.id;
    }
    /* Simple delete usages */
        
    store.getState().activityTypes
        .getMappingFor('activityCategoryId', activityCategory.id)
        .filter(activityTypeTemp => activityTypeTemp.status !== 'D')
        .forEach(activityTypeTemp => {
            const _activityType = activityTypeTemp.clone();
            _activityType.status =  'U';
            _activityType.addedOn = newHRTimestamp();
            _activityType.addedBy = getCurrentUserId();
            _activityType.importSource = targetImportSource;
            _activityType.importId = mergeId;

            _activityType.activityCategoryId = null;
            store.dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType));
        });

    /* Remove the actual activityCategory */
    activityCategory.status = 'D';
    activityCategory.addedOn = newHRTimestamp();
    activityCategory.addedBy = getCurrentUserId();
    activityCategory.importSource = targetImportSource;
    activityCategory.importId = mergeId;
    store.dispatch(Actions.ActivityCategoryActions.removeActivityCategoryQueue(activityCategory));
    
}

/*
 * Replace anywhere this activityCategory is used in other entities.
 *
 * @param {ActivityCategory} activityCategory
 * @param {ActivityCategory} replaceWith
 * @return {ActivityCategory} - ActivityCategory will have refs stripped away
 */
export function replaceActivityCategory(activityCategory: ActivityCategory, replaceWith: ActivityCategory, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = activityCategory.id;
    }
    /* Simple replace usages */
        
    store.getState().activityTypes
        .getMappingFor('activityCategoryId', activityCategory.id)
        .filter(activityTypeTemp => activityTypeTemp.status !== 'D')
        .forEach(activityTypeTemp => {
            const _activityType = activityTypeTemp.clone();
            _activityType.status =  'U';
            _activityType.addedOn = newHRTimestamp();
            _activityType.addedBy = getCurrentUserId();
            _activityType.importSource = targetImportSource;
            _activityType.importId = mergeId;

            _activityType.activityCategoryId = replaceWith.id;
            store.dispatch(Actions.ActivityTypeActions.saveActivityTypeQueue(_activityType));
        });

    return activityCategory;
}

/*
 * Determine the impact of deleting this activityCategory from other entities
 *
 * @param {ActivityCategory} activityCategory
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactActivityCategory(activityCategory: ActivityCategory) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const activityTypeActivityCategoryIdImpact = state.activityTypes
          .getMappingFor('activityCategoryId', activityCategory.id)
          .filter(activityType => activityType.status !== 'D');

    activityTypeActivityCategoryIdImpact.forEach(() => impacts.push('activityTypes'));

    return util.countDistinct(impacts);
}